<template>
  <div>
    <div v-if="!$store.getters.token">
      <!-- 登入-桌機彈窗 -->
      <div v-if="$store.state.user.isLoginActive" class="popup-wrap popup-login" :class="{ active: $store.state.user.isLoginActive }">
        <div class="popup-box">
          <a class="popup-close" @click="deactivatePopup" />
          <i class="content-left" />
          <div class="content">
            <div class="form-wrap ">
              <h5>{{ $t("Bao.login_play") }}</h5>
              <div class="login-tabs">
                <ul>
                  <li :class="{ 'active': (loginType==='username') }" @click="switchLoginType('username')">
                    <i class="icon-account" />{{ $t("Bao.username") }}
                  </li>
                  <li :class="{ 'active': (loginType==='phone') }" @click="switchLoginType('phone')">
                    <i class="phone" />{{ $t("Bao.phone") }}
                  </li>
                </ul>
              </div>
              <!--帳號登入-->
              <div v-if="loginType==='username'" class="form-input-1" :class="{ 'form-input-error-1': errors.has('username') }">
                <label for="username">
                  <i><img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-account.png`)" alt=""></i>
                  {{ $t("Bao.username") }}
                </label>

                <input
                  v-model="postForm.username"
                  v-validate="'required'"
                  class="float_register_ipt w-100 vti__input text-black"
                  :placeholder="$t('Bao.username_require')"
                  type="text"
                  name="username"
                  :data-vv-as="$t('Bao.username')"
                  autocomplete="off"
                >
                <div v-if="errors.has('username')&&loginType==='username'" class="help-block">
                  {{ $t("Bao.user_name_error") }}
                </div>
              </div>
              <!--手機號碼登入-->
              <div v-if="loginType==='phone'" class="form-input-1 form-county-code-1" :class="{ 'form-input-error-1': errors.has('username') }">
                <label for="username">
                  <i><img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-phone.png`)" alt=""></i>
                  {{ $t("Bao.phone") }}
                </label>
                <div class="form-select-1" :class="{ 'active': isFlagShow }" @click="toggleFlagShow">
                  <div class="form-select-value">
                    <img :src="require(`@/assets/${$store.getters.currentTheme}/images/japan.png`)" alt="">
                  </div>
                </div>
                <input
                  v-model="postForm.username"
                  v-validate="'required'"
                  type="text"
                  name="username"
                  :data-vv-as="$t('Bao.phone')"
                  :required="true"
                  autocomplete="off"
                >
                <div v-if="errors.has('username')&&loginType==='phone'" class="help-block">
                  {{ $t("Bao.login_phone_error") }}
                </div>
              </div>

              <div class="form-input-1" :class="{ 'form-input-error-1': errors.has('passwordz') }">
                <label for="passwordz">
                  <i><img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-password.png`)" alt=""></i>
                  {{ $t("Bao.password") }}
                </label>

                <input
                  v-model="postForm.password"
                  v-validate="'required'"
                  type="password"
                  :placeholder="$t('Bao.password_require')"
                  name="passwordz"
                  :data-vv-as="$t('Bao.password')"
                  autocomplete="new-password"
                >
                <!-- passwordz 欺騙瀏覽器避免自動填入 並改變樣式 -->
                <div v-if="errors.has('passwordz')" class="help-block">
                  {{ $t("Bao.new_password_error") }}
                </div>
                <div v-if="errors.has('password')" class="help-block">
                  {{ $t("Bao.new_password_error") }}
                </div>
              </div>
              <div class="form-text-login">
                <a @click="navigateToRegister">
                  {{ $t("Bao.login_create_account") }}
                </a>
                <a @click="navigateToForget">
                  {{ $t("Bao.forget_password") }}
                </a>
              </div>
              <div class="form-agree">
                <div class="form-button">
                  <button class="button-style-7" :disabled="actionLoading" type="button" @click="clickLogin()">
                    <span>{{ $t("Bao.login") }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 登入-手機版 -->
      <div v-if="$store.state.user.isLoginActive" class="mobile-login">
        <div class="content">
          <i class="login-logo">
            <img :src="require(`@/assets/${$store.getters.currentTheme}/images/login-logo.jpg`)" alt="">
          </i>
          <div class="form-wrap">
            <h5>{{ $t("Bao.login_play") }}</h5>
            <div class="login-tabs">
              <ul>
                <li :class="{ 'active': (loginType==='username') }" @click="switchLoginType('username')">
                  <i class="icon-account" />{{ $t("Bao.username") }}
                </li>
                <li :class="{ 'active': (loginType==='phone') }" @click="switchLoginType('phone')">
                  <i class="phone" />{{ $t("Bao.phone") }}
                </li>
              </ul>
            </div>
            <div v-if="loginType==='username'" class="form-input-1" :class="{ 'form-input-error-1': errors.has('username') }">
              <label for="">
                <i><img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-account.png`)" alt=""></i>
                {{ $t('Bao.username') }}
              </label>

              <input
                v-model="postForm.username"
                v-validate="'required'"
                class="float_register_ipt w-100 vti__input text-black"
                :placeholder="$t('Bao.username_require')"
                type="text"
                name="username"
                :data-vv-as="$t('Bao.username')"
                autocomplete="off"
              >
              <div v-if="errors.has('username')&&loginType==='username'" class="help-block">
                {{ $t("Bao.user_name_error") }}
              </div>
            </div>
            <!--手機號碼登入-->
            <div v-if="loginType==='phone'" class="form-input-1 form-county-code-1" :class="{ 'form-input-error-1': errors.has('username') }">
              <label for="">
                <i><img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-phone.png`)" alt=""></i>
                {{ $t('Bao.phone') }}
              </label>

              <div class="form-select-1" :class="{ 'active': isFlagShow }" @click="toggleFlagShow">
                <div class="form-select-value">
                  <img :src="require(`@/assets/${$store.getters.currentTheme}/images/japan.png`)" alt="">
                </div>
              </div>
              <input
                v-model="postForm.username"
                v-validate="'required'"
                type="text"
                name="username"
                :data-vv-as="$t('Bao.phone')"
                :placeholder="$t('Bao.phone_require')"
                :required="true"
                autocomplete="off"
              >
              <div v-if="errors.has('username')&&loginType==='phone'" class="help-block">
                {{ $t("Bao.login_phone_error") }}
              </div>
            </div>

            <div class="form-input-1" :class="{ 'form-input-error-1': errors.has('passwordz') }">
              <label for="passwordz">
                <i><img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-password.png`)" alt=""></i>
                {{ $t("Bao.password") }}
              </label>
              <input
                v-model="postForm.password"
                v-validate="'required'"
                type="password"
                :placeholder="$t('Bao.password_require')"
                name="passwordz"
                :data-vv-as="$t('Bao.password')"
                autocomplete="new-password"
              >
              <!-- passwordz 欺騙瀏覽器避免自動填入 並改變樣式 -->
              <div v-if="errors.has('passwordz')" class="help-block">
                {{ $t("Bao.new_password_error") }}
              </div>
              <div v-if="errors.has('password')" class="help-block">
                {{ $t("Bao.new_password_error") }}
              </div>
            </div>

            <div class="form-text-login">
              <a @click="navigateToRegister">
                {{ $t("Bao.login_create_account") }}
              </a>
              <a @click="navigateToForget">
                {{ $t("Bao.forget_password") }}
              </a>
            </div>
            <div class="form-agree">
              <div class="form-button">
                <button class="button-style-7" :disabled="actionLoading" type="button" @click="clickLogin()">
                  <span>{{ $t("Bao.login") }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '@/api/user'
import { login as localLogin } from '@/utils/user'
import { showNotice } from '@/utils/tool'

export default {

  data() {
    const postForm = {
      username: null,
      phone: null,
      password: null,
      captcha: null
    }
    return {
      loginType: 'username', // username, phone
      postForm,
      actionLoading: false,
      isFlagShow: false,
      previousUsername: ''
    }
  },
  created() {
  },
  methods: {
    switchLoginType(loginType) {
      this.loginType = loginType
      this.postForm = {}
      this.$validator.errors.items = []
    },
    formatPhoneNumber(input) {
      if (this.loginType !== 'username') {
        const str = '' + input
        return '+81 ' + str.slice(0, 2) + '-' + str.slice(2, 6) + '-' + str.slice(6)
      }
    },
    toggleFlagShow() {
      this.isFlagShow = !this.isFlagShow
    },
    deactivatePopup() {
      this.$store.commit('SET_LOGIN_OPEN', false)
    },
    navigateToRegister() {
      this.$store.commit('SET_LOGIN_OPEN', false)
      this.$store.commit('SET_REGISTER_OPEN', true)
    },
    navigateToForget() {
      this.$store.commit('SET_LOGIN_OPEN', false)
      this.$store.commit('SET_FORGET_OPEN', true)
    },
    clickLogin() {
      if (this.loginType === 'phone' && this.postForm.username !== null && this.postForm.username !== this.previousUsername) {
        this.postForm.username = this.formatPhoneNumber(this.postForm.username)
        this.previousUsername = this.postForm.username
      }
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.actionLoading = true
          login(this.postForm).then(response => {
            const tokenData = response.data.data.token
            const expiredTime = new Date().getTime() + (tokenData.expired_interval * 1000)
            localStorage.setItem('expired_time', expiredTime)
            localStorage.setItem('token', tokenData.token)
            this.$store.commit('SET_LOGIN_TO_EVENT', true)
            this.$store.commit('SET_LOGIN_OPEN', false)
            this.$store.commit('SET_READ_TERMS', false)

            let redirect = ''
            if (localStorage.getItem('redirectAfterLogin')) {
              redirect = this.$store.state.user.dailyItem.link
              localStorage.removeItem('redirectAfterLogin')
              this.$store.commit('SET_DAILY', false)
              this.$store.commit('SET_DAILY_ITEM', null)
              this.$store.commit('SET_LOGIN_TO_EVENT', false)
            } else if (this.$store.getters.inviteCode !== null) {
              redirect = 'user'
            }

            localLogin(response.data.data, redirect)
          }).catch(error => {
            if (error && error.response) {
              const errorCode = error.response.data.data.code[0]

              let errorMessage = ''
              switch (errorCode) {
                case '1':
                  errorMessage = this.$t('Bao.login_error1', { time: new Date(error.response.data.data.time[0] * 1000).toLocaleString() })
                  break
                case '2':
                  errorMessage = this.$t('Bao.login_error2')
                  break
                case '3':
                  errorMessage = this.$t('Bao.login_error3')
                  break
                case '4':
                  errorMessage = this.$t('Bao.login_error4')
                  break
                case '5':
                  errorMessage = this.$t('Bao.login_error5')
                  break
                default:
                  errorMessage = 'An unknown error occurred. Please try again.'
              }

              showNotice(errorMessage)
            } else {
              console.log(error)
            }
          }).finally((e) => {
            this.actionLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .mobile-login {
    z-index: 10;
  }
</style>
